<template>
  <st-scrolly>
    <template v-slot:background="{slideIndex, enter, exit}">
      <div class="scrolly-content">
        <scrolly-svg v-if="!attributes.mode || attributes.mode ==='svg'" :rootFolder="attributes.value" :index="slideIndex + 1"/>
        <scrolly-image v-else-if="attributes.mode === 'image'"
          :attributes="attributes"
          :scrollInfo="{slideIndex, enter, exit}"/>
      </div>
    </template>

    <div class="slide" :style="slideStyle(i)" v-for="(slideText, i) in attributes.p" :key="i">
      <div class="slide-content">
        <img v-if="attributes.thumbnail && attributes.thumbnail[i]" :src="require(`images/${attributes.thumbnail[i]}`)">
        <p v-markdown="slideText"></p>
      </div>
    </div>
  </st-scrolly>
</template>

<script>
import StScrolly from './StScrolly.vue'
import ScrollyImage from './ScrollyImage.vue'
import ScrollySvg from './ScrollySvg.vue'

export default {
  name: 'Scrolly',
  props: ['attributes'],
  data () {
    return {
      initHeight: this.$window.innerHeight
    }
  },
  components: {
    StScrolly,
    ScrollyImage,
    ScrollySvg
  },
  computed: {
    slideHeight () {
      return this.initHeight < 800 ? 800 : this.initHeight
    }
  },
  methods: {
    slideStyle (i) {
      const isLast = i === this.attributes.p.length - 1

      return {
        paddingTop: `${this.slideHeight}px`,
        paddingBottom: isLast ? `${this.slideHeight}px` : 0
      }
    }
  }
}
</script>

<style lang="scss">
.component-content {
  &:not(.fullwidth) {
    .background {
      @include container;
    }
  }
}

.st-scrolly {
  .background-container {
    .background > * {
      overflow: hidden;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .slide-container {
    @include container;

    .slide {
      .slide-content {
        display: inline-block;
        margin: 10px;
        background-color: #FFFFFF;
        max-width: 400px;

        img {
          display: block;
          width: 100%;
        }

        p {
          font-size: 20px;
          line-height: 31px;
          color: $black;
          padding: 10px 15px 20px;

          @include breakpoint($d_medium) {
            font-size: 22px;
          }

          &:only-child {
            padding: 15px 15px 20px;
          }
        }
      }
    }
  }
}
</style>
